export const emergencyprocedures = [
  {
    "@class": "com.portbase.bezoekschip.common.api.emergencyprocedure.EmergencyProcedure",
    "portUnCode": "NLRTM",
    "enabled": true,
    "sessionId": "07993350-a8da-441f-99aa-67c2a98c5d0f",
    "activatedAt": "2026-07-30T11:41:58.263863561Z"
  },
  {
    "@class": "com.portbase.bezoekschip.common.api.emergencyprocedure.EmergencyProcedure",
    "portUnCode": "NLAMS",
    "enabled": false,
    "sessionId": "eadfd242-3304-425b-8531-c9ad7fce6609",
    "activatedAt": "2026-07-30T11:09:07.585648043Z"
  }
];

export const emergencyProcedureMutations = [
  {
    "crn": "NLRTM21900001",
    "timestamp": "2025-06-15T09:30:00Z",
    "movementTarget": {
      "berthVisitId": "BV-EMH-001",
      "exitPoint": false
    },
    "userFullName": "Jan de Havenmeester",
    "mutation": {
      "portVisit": {
        "etaPbp": "2025-06-15T06:00:00Z",
        "pbp": "Maascenter",
        "etdPort": "2025-06-15T18:00:00Z",
        "atdPort": null
      },
      "portAuthority": {
        "clearances": {
          "ekh": {
            "status": "APPROVED",
            "remarks": null,
            "attentionPoints": []
          },
          "mdoh": {
            "status": "ACTIONS_REQUIRED",
            "remarks": "Health declaration approved with conditions",
            "attentionPoints": [
              {"type": "HEALTH_MEASURES_IMPOSED", "remarks": "Quarantine inspection on arrival"},
              {"type": "DECLARATION_INVALID", "remarks": "Resubmit MDOH before berthing"}
            ]
          },
          "sspi": {
            "status": "APPROVED",
            "remarks": null,
            "attentionPoints": []
          },
          "emas": {
            "status": "APPROVED",
            "remarks": null,
            "attentionPoints": []
          },
          "emgs": {
            "status": "REJECTED",
            "remarks": "Non-compliant packaging",
            "attentionPoints": [
              {"type": "DG_NOTIFICATION_NOT_RECEIVED", "remarks": "IMDG notification missing"},
              {"type": "DG_DISCHARGE_INFORMATION_NOT_RECEIVED", "remarks": "Provide discharge plan"}
            ]
          }
        },
        "operationalContact": true,
        "actualVesselDraft": 850,
        "tidalWindow": true,
        "tidalWindowStart": "2025-06-15T08:00:00Z",
        "tidalWindowEnd": "2025-06-15T12:00:00Z",
        "pilotFromDistance": true,
        "pilotFromDistanceAccepted": true,
        "onHold": false,
        "onHoldDate": null
      },
      "services": {
        "pilot": true,
        "pilotApproval": "ACCEPTED",
        "tugboat": true,
        "tugboatOrganisation": "SMIT",
        "numberOfTugboats": 2,
        "boatmen": true,
        "boatmenOrganisation": "KRVE"
      },
      "berth": {
        "code": "EMH",
        "eta": "2025-06-15T10:00:00Z",
        "etd": "2025-06-15T16:00:00Z",
        "ata": null,
        "atd": null,
        "bollardFrom": 100,
        "bollardTo": 200,
        "mooringPosition": "STARBOARD"
      }
    }
  },
  {
    "crn": "NLRTM21900002",
    "timestamp": "2025-06-15T10:15:00Z",
    "movementTarget": {
      "berthVisitId": "BV-WAALHAVEN-002",
      "exitPoint": true
    },
    "userFullName": "Bert de Loods",
    "mutation": {
      "portVisit": {
        "etaPbp": "2025-06-15T07:30:00Z",
        "pbp": "Hoek van Holland",
        "etdPort": "2025-06-15T19:30:00Z",
        "atdPort": null
      },
      "portAuthority": {
        "clearances": {
          "ekh": {
            "status": "APPROVED",
            "remarks": null,
            "attentionPoints": []
          },
          "mdoh": {
            "status": "APPROVED",
            "remarks": null,
            "attentionPoints": []
          },
          "sspi": {
            "status": "REJECTED",
            "remarks": "Security notification incomplete",
            "attentionPoints": []
          }
        },
        "operationalContact": false,
        "actualVesselDraft": 620,
        "tidalWindow": false,
        "tidalWindowStart": null,
        "tidalWindowEnd": null,
        "pilotFromDistance": false,
        "pilotFromDistanceAccepted": null,
        "onHold": false,
        "onHoldDate": null
      },
      "services": {
        "pilot": true,
        "pilotApproval": "ACCEPTED",
        "tugboat": true,
        "tugboatOrganisation": "KOTUG",
        "numberOfTugboats": 3,
        "boatmen": false,
        "boatmenOrganisation": null
      },
      "berth": {
        "code": "WAALHAVEN",
        "eta": "2025-06-15T11:30:00Z",
        "etd": "2025-06-15T17:30:00Z",
        "ata": null,
        "atd": null,
        "bollardFrom": 50,
        "bollardTo": 120,
        "mooringPosition": "PORT"
      }
    }
  },
  {
    "crn": "NLRTM21900001",
    "timestamp": "2025-06-15T11:45:00Z",
    "movementTarget": {
      "berthVisitId": "BV-EMH-001",
      "exitPoint": false
    },
    "userFullName": "Jan de Havenmeester",
    "mutation": {
      "portVisit": {
        "etaPbp": null,
        "pbp": null,
        "etdPort": null,
        "atdPort": null
      },
      "portAuthority": {
        "clearances": {
          "sspi": {
            "status": "ACTIONS_REQUIRED",
            "remarks": "Approved pending CSO data",
            "attentionPoints": [
              {"type": "CSO_DATA_INCOMPLETE", "remarks": "CSO contact details missing"}
            ]
          }
        },
        "operationalContact": null,
        "actualVesselDraft": 840,
        "tidalWindow": null,
        "tidalWindowStart": null,
        "tidalWindowEnd": null,
        "pilotFromDistance": null,
        "pilotFromDistanceAccepted": null,
        "onHold": true,
        "onHoldDate": "2025-06-15T11:40:00Z"
      },
      "services": null,
      "berth": null
    }
  }
];
